import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Container, Tabs, Tab, InputGroup, Form, Row, Col, Alert, Button } from 'react-bootstrap';
import { BsFillBoxFill } from "react-icons/bs";
import DaftarRegistrasiPasien from '../daftarregistrasipasien/DaftarRegistrasiPasien';
import RekamMedis from '../rekammedis/RekamMedis';
import $ from 'jquery';
const Home = () => {
    const [isSearch, setisSearch] = useState(true)

    const searchKeyDown = event => {
        if (event.key == 'Enter') {
            localStorage.setItem('rm', $('#search-rm-val').val())
            setisSearch(false);
        }
    }

    const handleGo = () => {
        if (!$('#search-rm-val').val()) {
            alert('Masukkan No. MR dahulu')
            return;
        }
        localStorage.setItem('rm', $('#search-rm-val').val())
        setisSearch(false);
    }

    useEffect(() => {
        if (localStorage.getItem('rm')) {
            localStorage.removeItem('rm');
        }
    }, [])
    return (
        <React.Fragment>
            <div className='justify-content-center'>
                {
                    isSearch ? (
                        <>
                            <div className="d-flex justify-content-center align-items-center bg-light" style={{ height: '90vh' }}>
                                <Row className='text-center'>
                                    <Col md={12}>
                                        <h4>Pencarian No Medical Record</h4>
                                        <span className='fs-6'>Tuliskan No MR pada tombol pencarian dibawah ini.dengan mengklik tombol Go..! menuju page data pasien</span>
                                    </Col>
                                    <Col className='mt-4'>
                                        <Row className="justify-content-md-center">
                                            <Col md="auto">
                                                <InputGroup className="mb-3" size="lg">
                                                    <InputGroup.Text id="search-rm">RM</InputGroup.Text>
                                                    <Form.Control
                                                        placeholder="rekam medis"
                                                        aria-label="rekam medis"
                                                        aria-describedby="search-rm"
                                                        id="search-rm-val"
                                                        onKeyDown={searchKeyDown}
                                                    />
                                                    <Button variant="outline-secondary btn-success text-white" id="button-addon2" onClick={() => handleGo()}>
                                                        Go
                                                    </Button>
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                    <span className='fs-6'>Lakukan Logout setelah selesai</span>
                                    </Col>
                                </Row>
                            </div>
                        </>
                    ) : (
                        <>
                        <RekamMedis/>
                        {/*<Tabs
                            defaultActiveKey="rekammedis"
                            id="uncontrolled-tab-example"
                            fill
                        >
                            {/* <Tab eventKey="daftarregistrasipasien" title="Daftar Registrasi Pasien">
                            <DaftarRegistrasiPasien/>
                        </Tab> 
                            <Tab eventKey="rekammedis" title="Rekam Medis">
                                <RekamMedis />
                            </Tab>
                        </Tabs>
                        */}
                        </>
                    )
                }

            </div>
        </React.Fragment>
    )
}
export default Home;